export const itemHeaderPrint = "Ogb";
export default {itemHeaderPrint};